const DuplicateProject = ({ oldName }: any) => {
  return (
    <div className='text-center px-5'>
      <div className='text-2xl font-bold mb-2'>Name Your Project</div>
      <div className='text-grey mb-5'>
        Name your design and we'll save it in My Projects.
      </div>
      <div className='my-4'>
        <input
          className='border border-solid border-[#939393] block mx-auto w-full max-w-[440px] p-2 rounded-md mb-3'
          type='text'
          placeholder='Enter Your New Project Name Here....'
          defaultValue={oldName + ' copy'}
          maxLength={25}
        />
        <div className='text-xs text-grey italic'>
          25 characters max, no symbols except dashes
        </div>
      </div>
      <button className='max-sm:w-full w-[50%] text-center block bg-primaryred text-white font-bold	text-xl py-2 px-7 rounded-full mx-auto my-4'>
        Duplicate 👉🏻
      </button>
    </div>
  );
};
export default DuplicateProject;
